import dayjs from "dayjs";

// Currency formatting
export function currencyFormat(value: number, currency: string = 'GBP', locale: string = 'en-GB') {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency
  }).format(value);
}

// Date formatting
export function formatDate(date: string | Date, format: string = 'DD/MM/YYYY') {
  return dayjs(date).format(format);
}

export function formatDateTime(date: string | Date, format: string = 'DD/MM/YYYY HH:mm') {
  return dayjs(date).format(format);
}

export function formatRelativeDate(date: string | Date) {
  return dayjs(date).fromNow();
}

// String formatting
export function truncateString(value: string, length: number) {
  return value.length > length ? `${value.substring(0, length)}...` : value;
}

export function removeHTMLTagsString(value: string) {
  return value.replace(/<[^>]*>?/gm, " ");
}

export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function toTitleCase(str: string) {
  return str.replace(/\w\S*/g, (txt) => 
    txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  );
}

// Color utilities
export function foreColorForBack(hex: string) {
  /*
  From this W3C document: http://www.webmasterworld.com/r.cgi?f=88&d=9769&url=http://www.w3.org/TR/AERT#color-contrast
  Color brightness is determined by the following formula:
  ((Red value X 299) + (Green value X 587) + (Blue value X 114)) / 1000
  */
  const threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background  */

  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });

  const hRed = hexToR(hex);
  const hGreen = hexToG(hex);
  const hBlue = hexToB(hex);

  function hexToR(h: string) { return parseInt(cutHex(h).substring(0, 2), 16); }
  function hexToG(h: string) { return parseInt(cutHex(h).substring(2, 4), 16); }
  function hexToB(h: string) { return parseInt(cutHex(h).substring(4, 6), 16); }
  function cutHex(h: string) { return (h.charAt(0) === "#") ? h.substring(1, 7) : h; }

  const cBrightness = ((hRed * 299) + (hGreen * 587) + (hBlue * 114)) / 1000;

  return cBrightness > threshold ? "#000000" : "#ffffff";
}

// File size formatting
export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes';
  
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

// Phone number formatting
export function formatPhoneNumber(phone: string): string {
  // Remove all non-digit characters
  const cleaned = phone.replace(/\D/g, '');
  
  // Format based on length
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  } else if (cleaned.length === 11) {
    return `+${cleaned.slice(0, 1)} (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
  }
  
  return phone; // Return original if can't format
} 
